module.exports = __webpack_public_path__ + "img/todov3-details2.22ad1ad7.png";